import { useContext } from 'react';
import { __RouterContext } from 'react-router';

const Context = () => useContext(__RouterContext);
export default Context;
